/**
 * The click event to listen to
 * @return {String} Returns `touchstart` if available, otherwise `click
 */
var clickEvent = function clickEvent() {
  return 'touchstart' in window ? 'touchstart' : 'click';
};

export default clickEvent;